const GET_PRODUCTS = 'publicador/step4Module1/GET_PRODUCTS';
const GET_PRODUCTS_COMPLETED = 'publicador/step4Module1/GET_PRODUCTS_COMPLETED';
const GET_PRODUCTS_FAILED = 'publicador/step4Module1/GET_PRODUCTS_FAILED';
const GET_CREDITS = 'publicador/step4Module1/GET_CREDITS';
const GET_CREDITS_COMPLETED = 'publicador/step4Module1/GET_CREDITS_COMPLETED';
const GET_CREDITS_FAILED = 'publicador/step4Module1/GET_CREDITS_FAILED';
const SELECT_PLAN = 'publicador/step4Module1/SELECT_PLAN';
const BUY_FREEMIUM = 'publicador/step4Module1/BUY_FREEMIUM';
const BUY_FREEMIUM_COMPLETED = 'publicador/step4Module1/BUY_FREEMIUM_COMPLETED';
const BUY_FREEMIUM_FAILED = 'publicador/step4Module1/BUY_FREEMIUM_FAILED';
const CLEAN_RESPONSE = 'publicador/step4Module1/CLEAN_RESPONSE';

export {
  GET_PRODUCTS,
  GET_PRODUCTS_COMPLETED,
  GET_PRODUCTS_FAILED,
  GET_CREDITS,
  GET_CREDITS_COMPLETED,
  GET_CREDITS_FAILED,
  SELECT_PLAN,
  BUY_FREEMIUM,
  BUY_FREEMIUM_COMPLETED,
  BUY_FREEMIUM_FAILED,
  CLEAN_RESPONSE
};
